class PaymentOrderDetailsModel {
  orderId!: string;
  pgOrderId!: string;
  razorpayKey!: string;
  amountInLeastSubunit!: number;
  amount!: number;
  currency!: string;
  companyName!: string;
  companyDescription!: string;
  image!: string;
  preFillEmail!: string;
  preFillName!: string;
  preFillContact!: string;
  originalAmountInLeastSubunit!: number;
  originalAmount!: number;
  referralDiscountAmount!: number;
  paymentService: string;
  jusPayOrderTransactionDetails:
    | {
        paymentLink: string;
      }
    | undefined;

  constructor(orderDetails) {
    this.orderId = orderDetails.order_id;
    this.pgOrderId = orderDetails.pg_order_id;
    this.razorpayKey = orderDetails.razorpay_key;
    this.amountInLeastSubunit = orderDetails.amount_in_least_subunit;
    this.amount = orderDetails.amount;
    this.currency = orderDetails.currency;
    this.companyName = orderDetails.company_name;
    this.companyDescription = orderDetails.company_description;
    this.image = orderDetails.image;
    this.preFillEmail = orderDetails.prefill_email;
    this.preFillName = orderDetails.prefill_name;
    this.preFillContact = orderDetails.prefill_contact;
    this.originalAmountInLeastSubunit =
      orderDetails.original_amount_in_least_subunit;
    this.originalAmount = orderDetails.original_amount;

    this.referralDiscountAmount = orderDetails.referral_discount_amount;
    this.paymentService = orderDetails.payment_service;

    this.jusPayOrderTransactionDetails =
      orderDetails.juspay_order_transaction_details
        ? {
            paymentLink:
              orderDetails.juspay_order_transaction_details.payment_link
          }
        : undefined;
  }
}

export default PaymentOrderDetailsModel;
